<header class="ss-header">
  <div class="ss-header__left">
    <button class="ss-header__menu-btn" type="button" (click)="toggleSidebarState()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="ss-header__title-block">
      <h1 class="ss-header__title">{{ getTitle() }}</h1>
      <app-ui-breadcrumb [items]="breadcrumbs"></app-ui-breadcrumb>
    </div>
  </div>

  <div class="ss-header__right">
    <app-ui-app-badge label="SupplySync"></app-ui-app-badge>

    <div class="ss-header__year">
      <mat-form-field appearance="outline" class="ss-header__year-field">
        <mat-label>Financial Year</mat-label>
        <mat-select [(ngModel)]="selectedFinancialYears" multiple (selectionChange)="onFinancialYearChange()">
          <mat-option *ngFor="let year of financialYears" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="ss-header__app-select">
      <select [value]="selectedApp" (change)="onAppChange($event.target.value)">
        <option value="">Choose app</option>
        <option value="centralhubdashboard">Central Hub</option>
        <option value="supplysync">SupplySync</option>
        <option value="stocksphere">StockSphere</option>
      </select>
    </div>

    <app-ui-user-menu
      [userName]="userName || 'Admin'"
      [companyName]="company_name || ''"
      [initials]="userInitials"
      (logout)="logout()">
    </app-ui-user-menu>
  </div>
</header>
